import React, { useEffect, useState } from 'react';
import { formatEmployeeNameForClient, getEmployeeInitials } from '../storefront-shared/utils/employeeNameUtils';
import './StorefrontStaffSelectionGrid.css';

function StaffTile({ employee, isSelected, onSelect }) {
  const [imgFailed, setImgFailed] = useState(false);

  useEffect(() => {
    setImgFailed(false);
  }, [employee.photoURL]);

  const hasUrl = Boolean(employee.photoURL);
  const showImg = hasUrl && !imgFailed;
  const displayName = formatEmployeeNameForClient(employee);
  const isLogoTile = Boolean(employee.isAnyAvailable && employee.photoURL);

  return (
    <div
      className={`storefront-staff-tile ${isSelected ? 'storefront-staff-tile--selected' : ''}`}
      role="button"
      tabIndex={0}
      onClick={() => onSelect(employee)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect(employee);
        }
      }}
    >
      <div className="storefront-staff-tile__ring">
        {showImg ? (
          <img
            className={`storefront-staff-tile__img${isLogoTile ? ' storefront-staff-tile__img--logo' : ''}`}
            src={employee.photoURL}
            alt=""
            onError={() => setImgFailed(true)}
          />
        ) : (
          <span className="storefront-staff-tile__initials">{getEmployeeInitials(employee)}</span>
        )}
      </div>

      {isSelected ? <div className="storefront-staff-tile__check" aria-hidden>✓</div> : null}

      <p className="storefront-staff-tile__name">{displayName}</p>
    </div>
  );
}

export default function StorefrontStaffSelectionGrid({ employees, selectedStaff, onSelect }) {
  return (
    <div className="storefront-staff-grid">
      {employees.map((employee) => (
        <StaffTile
          key={employee.id}
          employee={employee}
          isSelected={selectedStaff?.id === employee.id}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
}
